import React from "react";
import { FormattedMessage } from "./FormattedMessage";
import { SelectedToken } from "../store/SelectedTokensStore";

interface NovaMessageProps {
  content?: string;
  isTyping?: boolean;
  selectedTokens?: Map<string, SelectedToken>;
}

const NovaMessage: React.FC<NovaMessageProps> = ({
  content,
  isTyping = false,
  selectedTokens = new Map(),
}) => {
  return (
    <div className="flex max-w-[400px] gap-3 w-full justify-start items-start transition-width duration-500 flex-col">
      <div className="flex flex-col justify-start max-w-[300px] w-full">
        <div className="pt-0 pb-2 flex justify-start items-center w-full">
          <div className="flex flex-row justify-start items-center gap-1">
            <img
              src="/images/app/Nova/Nova2.png"
              alt="Nova Logo"
              className="w-5 h-5 object-contain rounded-full"
            />
            <div
              className="select-none bg-clip-text text-center text-lg
          select-none
          bg-clip-text text-transparent uppercase leading-none tracking-[0px] px-1 font-[0] font-[700]
         bg-[radial-gradient(61.17%_178.53%_at_38.83%_-13.54%,#003330_0%,#003330_15%,#003330_35%,#003330_50%,#00FFD1_70%,#003330_85%,#003330_100%)]"
            >
              Nova
            </div>
          </div>
        </div>
        <article className="max-w-[300px] w-full flex flex-col justify-center p-3 border border-gray-900 bg-customGray/90 rounded-2xl relative">
          <div className="absolute inset-0 bg-black/[0.60] rounded-2xl z-0"></div>

          {isTyping ? (
            // Animation de typing
            <div className="flex items-center gap-3 z-[1]">
              {/* Petit loader rotatif 30x30 */}
              <div className="loader-wrapper-small">
                <div className="loader-small"></div>
              </div>

              {/* Texte "Nova is thinking..." avec animation des lettres */}
              <div className="flex items-center gap-1">
                <div className="flex">
                  <span className="loader-letter-small">N</span>
                  <span className="loader-letter-small">o</span>
                  <span className="loader-letter-small">v</span>
                  <span className="loader-letter-small">a</span>
                  <span
                    className="loader-letter-small"
                    style={{ marginRight: "4px" }}
                  ></span>
                  <span className="loader-letter-small">i</span>
                  <span className="loader-letter-small">s</span>
                  <span
                    className="loader-letter-small"
                    style={{ marginRight: "4px" }}
                  ></span>
                  <span className="loader-letter-small">t</span>
                  <span className="loader-letter-small">h</span>
                  <span className="loader-letter-small">i</span>
                  <span className="loader-letter-small">n</span>
                  <span className="loader-letter-small">k</span>
                  <span className="loader-letter-small">i</span>
                  <span className="loader-letter-small">n</span>
                  <span className="loader-letter-small">g</span>
                  <span className="loader-letter-small">.</span>
                  <span className="loader-letter-small">.</span>
                  <span className="loader-letter-small">.</span>
                </div>
              </div>
            </div>
          ) : (
            // Message normal
            <div className="prose break-words dark:prose-invert w-full prose-gray text-sm prose-p:leading-relaxed prose-pre:p-0 overflow-hidden z-[1] text-white">
              <FormattedMessage
                content={content || ""}
                selectedTokens={selectedTokens}
              />
            </div>
          )}
        </article>
      </div>
    </div>
  );
};

export default NovaMessage;
